import type { ContactLinkDto } from '../api/contacts';

const TOKEN_RE = /^[A-Za-z0-9_-]{43}$/;
const CLUSTER_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface ContactQrRoute {
  clusterId: string;
  token: string;
}

export function contactPageUrl(link: ContactLinkDto): string {
  return new URL(`/contact/${link.clusterId}/${link.token}`, window.location.origin).toString();
}

function parseContactQrPath(pathname: string): ContactQrRoute | null {
  const parts = pathname.split('/');
  if (parts.length !== 4 || parts[1] !== 'contact' || !CLUSTER_RE.test(parts[2]) || !TOKEN_RE.test(parts[3])) return null;
  return { clusterId: parts[2], token: parts[3] };
}

export function readPendingContactQr(): ContactQrRoute | null {
  const fromPath = parseContactQrPath(window.location.pathname);
  if (fromPath) {
    try { sessionStorage.setItem('hc_contactQr', JSON.stringify(fromPath)); } catch { /* приватный режим */ }
    window.history.replaceState(null, '', '/');
    return fromPath;
  }
  try {
    const raw = sessionStorage.getItem('hc_contactQr');
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ContactQrRoute>;
    return typeof parsed.clusterId === 'string' && CLUSTER_RE.test(parsed.clusterId) &&
      typeof parsed.token === 'string' && TOKEN_RE.test(parsed.token)
      ? { clusterId: parsed.clusterId, token: parsed.token }
      : null;
  } catch {
    return null;
  }
}

export function clearPendingContactQr() {
  try { sessionStorage.removeItem('hc_contactQr'); } catch { /* приватный режим */ }
}
